import { render, staticRenderFns } from "./SectionAttachmentDetail.vue?vue&type=template&id=a3a0b070"
import script from "./SectionAttachmentDetail.vue?vue&type=script&lang=js"
export * from "./SectionAttachmentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports